export default "__VITE_ASSET__280597e9__"